import { toast } from 'react-toastify';
import { API_DASHBOARD } from '../../views/MainLayout/components/shared/services/dashboard';
import { API_MENSAJES } from '../../views/MainLayout/components/shared/services/mensajes';
import { setErrorMessage } from '../../views/MainLayout/components/shared/helpers/functionalities';

const initialDashboard = {
    admin: {
        general: null,
        userMetrics: null,
        generalMetrics: null,
        plataformasGeneralMetrics: null,
        plataformasUserMetrics: null,
        stockMetrics: null,
        piezasMetrics: null,
        incidenciasMetrics: null,
        proveedoresMetrics: null,
        clientesMetrics: null,
    },
    user: { mensajes: null },
};

export const dashboardReducer = (state = initialDashboard, action) => {
    switch (action.type) {
        case 'dashboard/fullfilled': {
            if (action.payload.type === 'admin') {
                const newDash = {
                    ...state,
                    admin: { ...state.admin, general: action.payload.data },
                };
                return newDash;
            } else {
                const mensajes = action.payload.data
                    .filter((msj) => msj.visible)
                    .sort((a, b) => b.id - a.id);
                const newDash = {
                    ...state,
                    user: { ...state.user, mensajes: mensajes },
                };
                return newDash;
            }
        }
        case 'general-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, generalMetrics: action.payload },
            };
            return newDash;
        }
        case 'user-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, userMetrics: action.payload },
            };
            return newDash;
        }
        case 'plataformas-general-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: {
                    ...state.admin,
                    plataformasGeneralMetrics: action.payload,
                },
            };
            return newDash;
        }
        case 'desguaces-general-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: {
                    ...state.admin,
                    desguacesGeneralMetrics: action.payload,
                },
            };
            return newDash;
        }
        case 'desguace-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, desguacesMetrics: action.payload },
            };
            return newDash;
        }
        case 'plataformas-user-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: {
                    ...state.admin,
                    plataformasUserMetrics: action.payload,
                },
            };
            return newDash;
        }
        case 'clientes-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, clientesMetrics: action.payload },
            };
            return newDash;
        }
        case 'piezas-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, piezasMetrics: action.payload },
            };
            return newDash;
        }
        case 'incidencias-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, incidenciasMetrics: action.payload },
            };
            return newDash;
        }
        case 'proveedores-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, proveedoresMetrics: action.payload },
            };
            return newDash;
        }
        case 'recambistas-messages/fullfilled': {
            const mensajes = action.payload
                .filter((msj) => msj.visible)
                .sort((a, b) => b.id - a.id);
            const newDash = {
                ...state,
                user: { ...state.user, mensajes: mensajes },
            };
            return newDash;
        }
        case 'stock-metrics/fullfilled': {
            const newDash = {
                ...state,
                admin: { ...state.admin, stockMetrics: action.payload },
            };
            return newDash;
        }
        case 'stock-metrics/update': {
            const newResumen = state.admin.stockMetrics.resumen.map((platf) => {
                const updated = action.payload.find(
                    (p) => p.nombre === platf.nombre
                );
                return updated ? updated : platf;
            });
            const newDash = {
                ...state,
                admin: {
                    ...state.admin,
                    stockMetrics: {
                        ...state.admin.stockMetrics,
                        resumen: newResumen,
                    },
                },
            };
            return newDash;
        }
        default:
            return state;
    }
};

export const fetchDashboard = () => async (dispatch) => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_DASHBOARD.getAdminData();
        const data = await response.data;
        dispatch({ type: 'dashboard/fullfilled', payload: { type: 'admin', data: data } })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
};

export const fetchRefreshDashboard = () => async (dispatch) => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        dispatch({ type: 'loading/set', payload: true });
        const response = await API_DASHBOARD.refreshAdminData();
        const data = await response.data;
        dispatch({ type: 'dashboard/fullfilled', payload: { type: 'admin', data: data } })
        dispatch({ type: 'loading/set', payload: false });
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
};

export const fetchRecambistasMessages = () => async (dispatch) => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_MENSAJES.getMensajes();
        const data = await response.data;
        dispatch({ type: 'dashboard/fullfilled', payload: { type: 'user', data: data } })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
};

export const fetchUserMetrics =
    (userId, startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            const response = await API_DASHBOARD.getUserMetrics(
                userId,
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({ type: 'user-metrics/fullfilled', payload: data });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchGeneralMetrics =
    (startDate, endDate, view, clean_cache) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            dispatch({ type: 'loading/set', payload: true });
            const response = await API_DASHBOARD.getGeneralMetrics(
                startDate,
                endDate,
                view,
                clean_cache
            );
            const data = await response.data;
            dispatch({ type: 'general-metrics/fullfilled', payload: data });
            dispatch({ type: 'loading/set', payload: false });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchPlataformasGeneralMetrics =
    (startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            const response = await API_DASHBOARD.getPlataformasGeneralMetrics(
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({
                type: 'plataformas-general-metrics/fullfilled',
                payload: data,
            });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchPlataformasUserMetrics =
    (plataformaId, startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            const response = await API_DASHBOARD.getPlataformasUserMetrics(
                plataformaId,
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({
                type: 'plataformas-user-metrics/fullfilled',
                payload: data,
            });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchDesguacesGeneralMetrics =
    (startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            dispatch({ type: 'loading/set', payload: true });
            const response = await API_DASHBOARD.getDesguacesGeneralMetrics(
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({
                type: 'desguaces-general-metrics/fullfilled',
                payload: data,
            });
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

export const fetchDesguacesMetrics =
    (desguaceId, startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            dispatch({ type: 'loading/set', payload: true });
            const response = await API_DASHBOARD.getDesguacesMetrics(
                desguaceId,
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({ type: 'desguace-metrics/fullfilled', payload: data });
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

export const fetchClientesMetrics =
    (startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            const response = await API_DASHBOARD.getClientesMetrics(
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({ type: 'clientes-metrics/fullfilled', payload: data });
            dispatch({ type: 'loading/set', payload: false });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchProveedoresMetrics =
    (startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            const response = await API_DASHBOARD.getProveedoresMetrics(
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({ type: 'proveedores-metrics/fullfilled', payload: data });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchPiezasMetrics =
    (startDate, endDate, view) => async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            const response = await API_DASHBOARD.getPiezasMetrics(
                startDate,
                endDate,
                view
            );
            const data = await response.data;
            dispatch({ type: 'piezas-metrics/fullfilled', payload: data });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchIncidenciasMetrics =
    (resp, startDate, endDate, view, proveedorId, tipoPiezaId, culpa) =>
    async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            const response = await API_DASHBOARD.getIncidenciasMetrics(
                resp,
                startDate,
                endDate,
                view,
                proveedorId,
                tipoPiezaId,
                culpa
            );
            const data = await response.data;
            dispatch({ type: 'incidencias-metrics/fullfilled', payload: data });
            dispatch({ type: 'loading/set', payload: false });
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    };

export const fetchStockMetrics =
    (refresh = false) =>
    async (dispatch) => {
        dispatch({ type: 'loading/set', payload: true })

        try {
            dispatch({ type: 'loading/set', payload: true });
            const response = await API_DASHBOARD.getStockMetrics(refresh);
            const data = await response.data;
            dispatch({ type: 'stock-metrics/fullfilled', payload: data });
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

export const fetchStockUpdate = (newStock) => async (dispatch) => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_DASHBOARD.updateStockMetrics({
            newStock: newStock.map((platf) => ({
                plataforma: platf.nombre,
                stock: platf.stock_plataforma ?? 0,
                aumento: platf.aumento_plataforma ?? ''
            })),
        });
        const data = await response.data;
        dispatch({ type: 'stock-metrics/update', payload: newStock });
        return data;
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
};